module.exports = __webpack_public_path__ + "media/src/images/icons/inbox_emptystate-21c0deeac2cc02a97581f8ffe64dd2ff.svg";